export default __webpack_public_path__ + "static/media/LAS0870.34I-39519_-23419_0.6ae9bf98.jpg";